import { motion } from "framer-motion";
import { Eye, Heart, Flame } from "lucide-react";
import { useLang } from "../i18n";
import { SectionBackdrop } from "./SectionBackdrop";

const STEP_ICONS = [Eye, Heart, Flame];

export const Manifesto = () => {
  const { s } = useLang();
  return (
  <section id="journey" data-testid="manifesto-section" className="relative py-28 md:py-36 bg-luxury-dark border-y border-luxury-border/60">
    <SectionBackdrop id="journey" />
    <div className="relative max-w-7xl mx-auto px-4 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="text-center max-w-3xl mx-auto mb-20"
      >
        <p className="text-luxury-gold text-sm tracking-[0.35em] mb-6">{s.manifesto_eyebrow}</p>
        <h2 data-testid="manifesto-title" className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl text-luxury-bone leading-[1.25]">
          {s.manifesto_title_a} <span className="gold-gradient-text italic">{s.manifesto_title_b}</span>
        </h2>
      </motion.div>

      <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-14 lg:gap-10">
        <div
          data-testid="manifesto-connector-line"
          aria-hidden="true"
          className="hidden lg:block absolute top-10 inset-x-[18%] border-t-2 border-dashed border-luxury-gold/30"
        />
        <div
          aria-hidden="true"
          className="lg:hidden absolute top-12 bottom-12 start-10 border-s-2 border-dashed border-luxury-gold/25"
        />
        {s.chapters.map((ch, i) => {
          const Icon = STEP_ICONS[i % STEP_ICONS.length];
          return (
            <motion.div
              key={ch.num}
              data-testid={`manifesto-chapter-${i}`}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.15, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="relative flex lg:flex-col items-start lg:items-center gap-7 lg:text-center"
            >
              <div className="relative shrink-0">
                <div className="w-20 h-20 rounded-full border border-luxury-gold/40 bg-luxury-surface flex items-center justify-center shadow-[0_0_45px_rgba(201,164,92,0.15)]">
                  <Icon className="w-9 h-9 text-luxury-gold" strokeWidth={1.1} />
                </div>
                <span className="absolute -bottom-2 -end-2 bg-luxury-gold text-luxury-black text-xs font-bold rounded-full px-2.5 py-0.5 shadow-lg">
                  {ch.num}
                </span>
              </div>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl text-luxury-bone mb-3">{ch.title}</h3>
                <p className="text-sm md:text-base text-luxury-gray leading-loose max-w-md">{ch.text}</p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
  );
};
